
export {default as ResetPassword} from './_web/ResetPassword';

export {reset_pw_types} from './types'